import * as React from 'react';
import { cn } from '@noor/lib/cn';

/**
 * Fixed-color status glyphs for the result-alert dialogs, extracted verbatim
 * from the Noor.Merchant Figma file (success node 119:7699 / error node
 * 119:7705). Like `WarningOctagonIcon`, these carry the design's exact brand
 * tints and so do NOT follow `currentColor` — a success is always green, an
 * error always pink. Size them with `size-*` (native frame 72×72).
 */
export interface AlertStatusIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

/** Green filled check-circle — the "created successfully" alert glyph. */
export function CheckCircleIcon({ className, ...props }: AlertStatusIconProps) {
  return (
    <svg
      viewBox="0 0 72 72"
      fill="none"
      aria-hidden="true"
      className={cn('shrink-0', className)}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36 6C19.458 6 6 19.458 6 36C6 52.542 19.458 66 36 66C52.542 66 66 52.542 66 36C66 19.458 52.542 6 36 6ZM36 60C22.767 60 12 49.233 12 36C12 22.767 22.767 12 36 12C49.233 12 60 22.767 60 36C60 49.233 49.233 60 36 60Z"
        fill="#16BB63"
      />
      <path
        d="M29.9971 40.7611L23.1001 33.8761L18.8641 38.1241L30.0031 49.2391L50.1211 29.1211L45.8791 24.8791L29.9971 40.7611Z"
        fill="#16BB63"
      />
    </svg>
  );
}

/** Pink filled x-circle — the "something went wrong" alert glyph. */
export function XCircleIcon({ className, ...props }: AlertStatusIconProps) {
  return (
    <svg
      viewBox="0 0 72 72"
      fill="none"
      aria-hidden="true"
      className={cn('shrink-0', className)}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.516 48.7262L36 40.2422L44.484 48.7262L48.726 44.4842L40.242 36.0002L48.726 27.5162L44.484 23.2742L36 31.7582L27.516 23.2742L23.274 27.5162L31.758 36.0002L23.274 44.4842L27.516 48.7262Z"
        fill="#FA004B"
      />
      <path
        d="M36 66C52.542 66 66 52.542 66 36C66 19.458 52.542 6 36 6C19.458 6 6 19.458 6 36C6 52.542 19.458 66 36 66ZM36 12C49.233 12 60 22.767 60 36C60 49.233 49.233 60 36 60C22.767 60 12 49.233 12 36C12 22.767 22.767 12 36 12Z"
        fill="#FA004B"
      />
    </svg>
  );
}
